var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VTooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('VBtn',_vm._g({attrs:{"color":"red","icon":"","flat":"","small":"","disabled":_vm.$props.disabled},on:{"click":_vm.click}},on),[_c('VIcon',[_vm._v("delete")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$props.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }